jQuery(document).ready(function ($) {

    var module_name = 'c_t_a';

    $('.' + module_name.replace(/_/g, '-') + '-module').each(function (index) {
        let sticky_cta = $(this).find('.casino-review');
        let footer = $('.footer');
        let ctaElements = $(this).find('.module-inner').children().length <= 0;

        if(ctaElements){
            $(this).hide();
        }

        function checkOffset() {
            let a = $(document).scrollTop() + window.innerHeight;
            let b = $(footer).offset().top;

            if (a < b) {
                $(sticky_cta).css('bottom', 0);
            } else {
                $(sticky_cta).css('bottom', (20 + (a - b)) + 'px');
            }
        }

        if ($(window).width() < 576) {
            $(document).scroll(checkOffset);
        }
    });

    $('.casino-review').length > 0 ? $('.mobile-nav').addClass('mobile-nav--display') && $('.footer').addClass('footer--margin-top') : '';

    $('.mobile-nav').length > 0 && $('.casino-review').length == 0 ? $('footer').addClass('footer--margin-bottom') : '';
});
